// extracted by mini-css-extract-plugin
export default {"chat_icon":"NotesTooltip_chat_icon__QifFw"};